import * as THREE from 'three';

const vertexShader = `
attribute float scale;
uniform float uTime;
uniform float uSize;
uniform float uOpacity;
varying float vScale;
varying float vAlpha;

void main() {
  vScale = scale;
    vec4 mvPosition =
        modelViewMatrix * vec4(position, 1.0);

    vAlpha = uOpacity;

   gl_PointSize =
    scale * uSize * (8.0 / max(-mvPosition.z, 0.1));

    gl_Position =
        projectionMatrix * mvPosition;

}
`;

const fragmentShader = `
uniform vec3 uColor;
uniform float uTime;
varying float vAlpha;
varying float vScale;
void main() {

   
    vec2 uv = gl_PointCoord - vec2(0.5);

    float d = length(uv);

    float glow =
        smoothstep(0.5, 0.0, d);

    float core =
        smoothstep(0.12, 0.0, d);

   float horizontal =
    smoothstep(0.025, 0.0, abs(uv.y)) *
    smoothstep(0.35, 0.10, abs(uv.x));

float vertical =
    smoothstep(0.025, 0.0, abs(uv.x)) *
    smoothstep(0.35, 0.10, abs(uv.y));

    float star =
        max(horizontal, vertical);
	float twinkle =
    0.65 +
    0.35 *
    sin(
        uTime * 2.2 +
        vScale * 31.0
    );
   float alpha =
(
    glow * 0.25 +
    star * 0.55 +
    core
) * twinkle;

    gl_FragColor =
    vec4(
        uColor,
        alpha * vAlpha
    );
}
`;

export function createPointMaterial(options = {}) {

    const {

        color = 0x38bdf8,
        opacity = 0.95,
        size = 1.0,

        transparent = true,
        depthWrite = false,
        blending = THREE.AdditiveBlending

    } = options;

    return new THREE.ShaderMaterial({

        vertexShader,
        fragmentShader,

        uniforms: {

            uColor: {
                value: new THREE.Color(color)
            },

            uOpacity: {
                value: opacity
            },

		   uSize: {
			value: size
			},
			uTime: {
				value: 0
			},

        },

        transparent,
        depthWrite,
        blending

    });

}
